export default __webpack_public_path__ + "static/media/work.53f1b546.png";